// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18J7Z","toggle":"styles_toggle__3VMQ0","preview":"styles_preview__15dNh"};